import { component } from "picoapp";

export default component((node) => {
  const checkbox = node.querySelector('input[type="checkbox"]');
  checkbox.addEventListener("change", (e) => {
    const { checked, dataset } = e.target;
    const toggleEvent = new CustomEvent("option-change:color", {
      detail: {
        value: checked,
        checked: dataset.checked,
        unchecked: dataset.unchecked,
      },
    });
    window.dispatchEvent(toggleEvent);
  });
});
